export default "__VITE_ASSET__CcXCs6RQ__"